import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

import { isEmptyOrNil } from 'libs/empty'

const LabelError = ({ id, text }) => {
  return (
    <div
      id={id}
      data-testid={id}
      className="flex space-x-2 normal-case label-error mt-2"
    >
      {!isEmptyOrNil(text) && (
        <>
          <ErrorOutlineIcon className="text-red-500" fontSize="small" />
          <Typography className="text-red-500">{text}</Typography>
        </>
      )}
    </div>
  )
}

LabelError.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

export default LabelError
